export default {
  client_id: process.env.REACT_APP_GOOGLE_LOGIN_ID
 
}
